import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React from 'react';
import { Flex, Typography } from 'zui/Antd';

const { Text } = Typography;

const PanelHeader = ({ iconLeft, title, isExpanded, togglePanel }) => {
	// Theme tokens
	const {
		token: { paddingXS, fontSizeLG, colorTextLabel, colorText, fontWeightStrong, margin }
	} = theme.useToken();

	// Styled icon
	const styledIconLeft = iconLeft
		? React.cloneElement(iconLeft, {
				style: {
					fontSize: fontSizeLG,
					color: colorTextLabel,
					...(iconLeft.props?.style || {})
				}
		  })
		: null;

	const IconToggle = isExpanded ? UpOutlined : DownOutlined;

	return (
		<Flex align='center' justify='space-between' gap={paddingXS}>
			<Flex align='center' gap={paddingXS}>
				<IconToggle
					onClick={togglePanel}
					style={{
						cursor: 'pointer',
						fontSize: fontSizeLG,
						color: colorTextLabel,
						marginRight: margin
					}}
				/>
				{styledIconLeft}
				<Text style={{ fontSize: fontSizeLG, color: colorText, fontWeight: fontWeightStrong }}>{title}</Text>
			</Flex>
		</Flex>
	);
};

export default PanelHeader;
